import { getTravleDetailJ } from '@/axios/api'

const travleDetailJ = {
  state: {
    travleDetailJ: []
  },
  mutations: {
    SET_TRAVLEDETAILJ (state, travleDetailJ) {
      state.travleDetailJ = travleDetailJ
    }
  },
  actions: {
    TRAVLEDETAILJ ({ commit }, params) {
      getTravleDetailJ(params).then(res => {
        this.state.travleDetailJ = res.data.data
      })
    }
  }
}

export default travleDetailJ



// WEBPACK FOOTER //
// ./src/store/modules/getTravleDetailJ.js